import React, { useEffect, useState } from 'react'
import Header from '../../layout/Header'
import DoughnutChartWidget from '../Dashbaord/chart/DoughnutChartWidget'
import LineChartDashboard from '../Dashbaord/chart/LineChartDashboard'
import BarChartWeekly from '../Dashbaord/chart/BarChartWeekly'
// import RegionWiseUserChart from './RegionWiseUserChart'
import RegionWiseUserChart from "../Dashbaord/chart/RegionWiseUserChart"
import ScanAgingChart from '../Dashbaord/chart/ScanAgingChart'
import { generateLastNDaysData, getChartDataFromRaw, getChartDataFromRegions } from '../../../../utils/helper'
import { channelDashboard } from '../../../../components/pages/campaigns/services'
import { coupon, scan, top_performer } from "../../../../Image/Index";
import { getUserJourneyReport } from '../../../../actions/dashboard'
import { decrypt, encrypt } from '../../../../utils/encodingdecoding'
import { sobiscoMerchantId, starblazeMerchantId } from '../../../../utils'
import { Link } from 'react-router-dom'

const DashboardOld = () => {
    const [loader, setLoader] = useState(false)
    const [state, setState] = useState({
        users: {
            admin: 0,
            customerCP: 0,
            distributor: 0,
            retailer: 0,
            influencer: 0,
            totalUsers: 0
        },
        sobiscoUsers: {
            distributor: 0,
            wholesaler: 0,
            sales: 0,
            totalUsers: 0
        },
        userStatus: {
            approved: 0,
            pending: 0,
            reject: 0,
            suspect: 0

        },
        kycAndRedemption: {
            pending: 0,
            redeemRequest: 0
        },
        last30DaysScanning: [],
        scanningStatus: [],
        regionWise: [],
        scanAging: [],
        couponType: {
            item: "",
            box: ""
        },
        scanningType: {
            item: "",
            box: ""
        },
        topPerformers: []
    })
    const { users, sobiscoUsers, userStatus, kycAndRedemption, last30DaysScanning, scanningStatus, regionWise, scanAging, couponType, scanningType, topPerformers } = state
    const labels = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const regionLabels = ['North', 'East', 'West', 'South'];
    let id = decrypt(localStorage.getItem("Id"))

    useEffect(() => {
        const fetch = async () => {
            setLoader(true)
            try {
                const token = JSON.parse(localStorage.getItem("token_gen"));
                const Id = (localStorage.getItem("Id"));
                const response = await channelDashboard(token?.access_token, Id)
                if (response.message === "Success") {
                    const reportRes = await getUserJourneyReport(token?.access_token, Id)
                    localStorage.setItem("transactionSchema", reportRes?.transactionSchemaName);
                    localStorage.setItem("customerSchema", reportRes?.customerSchemaName);
                    localStorage.setItem("schemaId", encrypt(reportRes.transactionSchemaCode));
                    localStorage.setItem(
                        "schemaName",
                        encrypt(reportRes.transactionSchemaName)
                    );
                    const data = response.data
                    setState((prev) => ({
                        ...prev,
                        users: {
                            ...prev.users,
                            admin: data.users?.Admin || 0,
                            customerCP: data.users?.CustomerCP || 0,
                            distributor: data.users?.Distributor || 0,
                            retailer: data.users?.Retailer || 0,
                            influencer: data.users?.Influencer || 0,
                            totalUsers: data.users?.TotalUsers || 0,
                            blockUser: data.users?.blockUser || 0,
                        },
                        sobiscoUsers: {
                            ...prev.sobiscoUsers,
                            distributor: data.users?.Distributor || 0,
                            wholesaler: data.users?.Wholesaler || 0,
                            sales: data.users?.Sales || 0,
                            totalUsers: data.users?.TotalUsers || 0
                        },
                        userStatus: {
                            ...prev.userStatus,
                            approved: data.userStatus?.Approved || 0,
                            pending: data.userStatus?.Pending || 0,
                            reject: data.userStatus?.Reject || 0,
                            suspect: data.userStatus?.Suspect || 0

                        },
                        kycAndRedemption: {
                            ...prev.kycAndRedemption,
                            approved: data.kycStatus?.Approved || 0,
                            reject: data.kycStatus?.Reject || 0,
                            pending: data.kycStatus?.Pending || 0,
                            redeemRequest: data?.totalRedemptions || 0
                        },
                        last30DaysScanning: data?.last30DaysScanning || 0,
                        scanningStatus: data?.scanningStatus || 0,
                        regionWise: data?.regionWise || 0,
                        scanAging: data?.scanAging || 0,
                        couponType: {
                            ...prev.couponType,
                            item: data?.couponType?.Item || 0,
                            box: data?.couponType?.Box || 0,
                        },
                        scanningType: {
                            ...prev.scanningType,
                            item: data?.scanningType?.Item || 0,
                            box: data?.scanningType?.Box || 0,
                        },
                        topPerformers: data?.topPerformers || 0
                    }))
                }
            } catch (err) {
                setLoader(false)
            }
            setLoader(false)
        }

        fetch()
    }, [])

    const { boxData, itemData } = generateLastNDaysData(30, last30DaysScanning);
    const datasets = getChartDataFromRaw(scanningStatus);
    const weekData = {
        labels,
        datasets,
    };
    const { userCounts, scanningCounts } = getChartDataFromRegions(regionWise, regionLabels);

    return (
        <>
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <Header name={"Dashboard"} />
            <div className='dashboard_body'>
                <div className={id === sobiscoMerchantId ? "" : (id === starblazeMerchantId ? 'dashboard_chart_row_2col marbot-1' : 'dashboard_chart_row marbot-1')}>
                    {id === sobiscoMerchantId &&
                        <div className=" marbot-1">
                            <div className="cdashboard_box br-05">
                                <div className="total_users_row">

                                    <div className="stat_card total">
                                        <div className="stat_card_header">
                                            <h4>Total Users</h4>
                                        </div>
                                        <div className="stat_card_body">
                                            <h2>
                                                {/* <Link to="/channel-partner/user-list"> */}
                                                {(sobiscoUsers?.distributor || 0) +
                                                    (sobiscoUsers?.wholesaler || 0) +
                                                    (sobiscoUsers?.sales || 0)}
                                                {/* </Link> */}
                                            </h2>
                                        </div>
                                    </div>

                                    <div className="stat_card distributor">
                                        <div className="stat_card_header">
                                            <h4>Distributor</h4>
                                        </div>
                                        <div className="stat_card_body">
                                            <h2>
                                                {/* <Link to="/channel-partner/user-list?type=Distributor"> */}
                                                {sobiscoUsers?.distributor || 0}
                                                {/* </Link> */}
                                            </h2>
                                        </div>
                                    </div>

                                    <div className="stat_card wholesale">
                                        <div className="stat_card_header">
                                            <h4>Wholesaler</h4>
                                        </div>
                                        <div className="stat_card_body">
                                            <h2>
                                                {/* <Link to="/channel-partner/user-list?type=Wholesaler"> */}
                                                {sobiscoUsers?.wholesaler || 0}
                                                {/* </Link> */}
                                            </h2>
                                        </div>
                                    </div>

                                    <div className="stat_card sales">
                                        <div className="stat_card_header">
                                            <h4>Sales</h4>
                                        </div>
                                        <div className="stat_card_body">
                                            <h2>
                                                {/* <Link to="/channel-partner/user-list?type=Sales"> */}
                                                {sobiscoUsers?.sales || 0}
                                                {/* </Link> */}
                                            </h2>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    }
                    {id !== sobiscoMerchantId && <>
                        <div className='dashboard_chart_box'>
                            <DoughnutChartWidget
                                title={id === starblazeMerchantId ? "Total Retailers" : "Total Users"}
                                totalValue={users.totalUsers}
                                labels={id === starblazeMerchantId
                                    ? ["Active", "Inactive"]
                                    : ["Admin", "Customer", "Distributor", "Retailer", "Influencer"]}
                                data={id === starblazeMerchantId
                                    ? [(users.totalUsers - users.blockUser) || 0, users.blockUser || 0]
                                    : [users.admin, users.customerCP, users.distributor, users.retailer, users.influencer]}
                                colors={id === starblazeMerchantId
                                    ? ["#10B981", "#EF4444"]
                                    : ["#6366F1", "#0EA5E9", "#F59E0B", "#10B981", "#F43F5E"]}
                                legendData={id === starblazeMerchantId
                                    ? [(users.totalUsers - users.blockUser) || 0, users.blockUser || 0]
                                    : [users.admin, users.customerCP, users.distributor, users.retailer, users.influencer]}
                            />
                        </div>
                        {id !== starblazeMerchantId &&
                            <div className='dashboard_chart_box'>
                                <DoughnutChartWidget
                                    title={id === starblazeMerchantId ? "Retailer Status" : "User Status"}
                                    labels={["Approved", "Reject", "Pending", "Suspect"]}
                                    data={[userStatus.approved || 0, userStatus.reject, userStatus.pending, userStatus.suspect]}
                                    colors={["#10B981", "#EF4444", "#EAB308", "#94A3B8"]}
                                    legendData={[userStatus.approved, userStatus.reject, userStatus.pending, userStatus.suspect]}
                                />
                            </div>
                        }


                        <div className='dashboard_chart_box'>
                            <DoughnutChartWidget
                                title="KYC Status"
                                labels={id === starblazeMerchantId
                                    ? ["Approved", "Rejected", "Pending", ]
                                    : ["KYC Pending", "Redeem Request"]}
                                data={id === starblazeMerchantId
                                    ? [kycAndRedemption.approved || 0, kycAndRedemption.reject || 0, kycAndRedemption.pending || 0 || 0]
                                    : [kycAndRedemption.pending || 0, kycAndRedemption.redeemRequest || 0]}
                                colors={["#10B981", "#EF4444", "#EAB308", "#8B5CF6"]}
                                legendData={id === starblazeMerchantId
                                    ? [kycAndRedemption.approved, kycAndRedemption.reject, kycAndRedemption.pending,]
                                    : [kycAndRedemption.pending, kycAndRedemption.redeemRequest]}
                            />
                        </div>

                    </>}
                </div>

                <div className='dashboard_chart_row_2 marbot-1'>
                    <div className=''>
                        <div className='cdashboard_box whitebg bs br-05'>
                            <LineChartDashboard boxData={boxData} itemData={itemData} />
                        </div>
                    </div>
                    <div className=''>
                        <div className='cdashboard_box whitebg bs br-05'>
                            <BarChartWeekly weekData={weekData} />
                        </div>
                    </div>
                </div>

                <div className='dashboard_chart_row_3 marbot-1'>
                    <div className='w-100'>
                        <div className='dashboard_chart_large'>
                            <div className='cdashboard_region w-50 bs br-05'>
                                <div className='cdashboard_region_top'>
                                    <h4>Region Wise {id === starblazeMerchantId ? "Retailer" : "User"} v/s Scanning</h4>
                                </div>
                                <div className='cdashboard_region_bottom'>
                                    <RegionWiseUserChart userCounts={userCounts} scanningCounts={scanningCounts} height={300} />
                                </div>
                            </div>
                            <div className='cdashboard_scan w-50 bs br-05'>
                                <div className='cdashboard_scan_top'>
                                    <h4>Scan Aging</h4>
                                </div>
                                <div className='cdashboard_scan_bottom'>
                                    <ScanAgingChart daycount={scanAging?.[0]?.sevendaycount || 0} monthcount={scanAging?.[1]?.sixmonthcount || 0} notScan={scanAging?.[2]?.notscanning || 0} height={300} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='dashboard_chart_section'>
                    <div className='cdashboard_table'>
                        <div className='cdashboard_table_heading'>
                            <img src={top_performer} />
                            <h4>Top Performer</h4>
                        </div>
                        <div className='cdashboard_table_box'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Mobile</th>
                                        <th>Earn</th>
                                        <th>Source</th>
                                    </tr>
                                </thead>
                                {
                                    topPerformers?.length > 0 ? <tbody>
                                        {topPerformers?.map((ele, ind) => (
                                            <tr key={ind}>
                                                <td>{ele?.rank}</td>
                                                <td>{ele?.name}</td>
                                                <td>{ele?.mobileNo}</td>
                                                <td>{ele?.pointEarned}</td>
                                                <td>{ele?.source}</td>
                                            </tr>
                                        ))}
                                    </tbody> : <div>
                                        No Record Found
                                    </div>
                                }

                            </table>
                        </div>
                    </div>
                    <div className='dashboard_coupon'>
                        <div className='dashboard_coupon_box'>
                            <div className='dashboard_coupon_box_inner'>
                                <div className='dashboard_coupon_box_inner_left'>
                                    <img src={coupon} />
                                    <h5>Total <span>Coupon</span></h5>
                                </div>
                                <div className='dashboard_coupon_box_inner_right'>
                                    <div className='dashboard_coupon_box_inner_right_top'>
                                        <p>Item Coupon</p>
                                        <span>{couponType?.item || 0}</span>
                                    </div>
                                    <div className='dashboard_coupon_box_inner_right_bottom'>
                                        <p>Box Coupon</p>
                                        <span>{couponType?.box || 0}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='dashboard_coupon_box'>
                            <div className='dashboard_coupon_box_inner'>
                                <div className='dashboard_coupon_box_inner_left'>
                                    <img src={scan} />
                                    <h5>Total <span>Scanning</span></h5>
                                </div>
                                <div className='dashboard_coupon_box_inner_right'>
                                    <div className='dashboard_coupon_box_inner_right_top'>
                                        <p>Item Coupon</p>
                                        <span>{scanningType?.item || 0}</span>
                                    </div>
                                    <div className='dashboard_coupon_box_inner_right_bottom'>
                                        <p>Box Coupon</p>
                                        <span>{scanningType?.box || 0}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default DashboardOld

